import { Injectable, inject } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  // declare all characters
  private characters: string ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';  

  constructor() { }

  public getRandomString(length: number) {
    let result = ' ';
    const maxLength = this.characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += this.characters.charAt(Math.floor(Math.random() * maxLength));
    }
    return result;    
  }  

  public getRandomInt(maxInt: number) {
    return Math.floor(Math.random() * maxInt);
  }

  // Format a given date field 
  public formatDateFromISO(dt: string, format?: string, locale?: string): string | null {
    try {
      let date = new Date(dt);
      if (!format) {
        format = 'yyyy-MM-dd HH:mm:ss';
      }
      if (!locale) {
        locale = 'en-US';
      }
      const formattedDate = formatDate(date, format, locale);
      return formattedDate;
    } catch(error) {
      console.log(`Error in formatFromISO(); provided parameters: dt: ${dt} format: ${format} locale: ${locale}`, error);
      return null;
    }
  }

  // Format given date field from yyyy-mm-dd hh24:mi:ss to ISO
  public formatDateToISO(dt: string): string | null {
    try {
      const event = new Date(dt);
      return event.toISOString();
    } catch(error) {
      console.log(`Error in formatToISO(); provided parameter: ${dt}`, error);
      return null;
    }
  }  

  // Format given date field as yyyy-mm-dd
  public getFormattedDate(d: any) {
    if (d instanceof Date) {
      var day = String(d.getDate()).padStart(2, '0');
      var month = String(d.getMonth() + 1).padStart(2, '0'); //Months are zero based
      var year = d.getFullYear();
      return year + "-" + month + "-" + day;
    } else {
      return d;
    }
  }

  // Converts a 10-digit phone number to ISO format: +1-XXX-XXX-XXXX
  public formatPhoneToISO(phone: string): string | null {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length !== 10) return null;
    return `+1-${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  // Converts an ISO format phone number (+1-XXX-XXX-XXXX) back to 10-digit string
  public formatPhoneFomISO(isoPhone: string): string | null {
    const match = isoPhone.match(/^\+1-(\d{3})-(\d{3})-(\d{4})$/);
    if (!match) return null;
    return `${match[1]}${match[2]}${match[3]}`;
  }

  // This function checks whether a given string can be converted to a valid Date
  public isValidDateString(input: string): boolean {
    const date = new Date(input);
    return !isNaN(date.getTime());
  }


}
